import { all, takeEvery, put, fork, call } from "redux-saga/effects";
import { message } from "antd";
import actions from "./actions";

function getErrorMessage(error) {
  const data = error.response?.data;
  if (data?.message) return data.message;
  if (typeof data === "string") return data;
  return error.message || "Something went wrong. Please try again.";
}

export function* getClassifications() {
  yield takeEvery(actions.FETCH_CLASSIFICATIONS_REQUESTED, function* (action) {
    try {
      const classifications = yield call(
        actions.getClassifications,
        action.payload
      );

      yield put({
        type: actions.FETCH_CLASSIFICATIONS_SUCCEEDED,
        classifications,
      });
    } catch (error) {
      yield put({
        type: actions.FETCH_CLASSIFICATIONS_FAILED,
        error: error.message,
      });
    }
  });
}

export function* getClassification() {
  yield takeEvery(actions.FETCH_CLASSIFICATION_REQUESTED, function* (action) {
    try {
      const classification = yield call(
        actions.getClassification,
        action.payload
      );
      yield put({
        type: actions.FETCH_CLASSIFICATION_SUCCEEDED,
        classification: classification.classification_info,
      });
    } catch (error) {
      yield put({
        type: actions.FETCH_CLASSIFICATION_FAILED,
        error: error.message,
      });
    }
  });
}

export function* searchClassifications() {
  yield takeEvery(actions.SEARCH_CLASSIFICATION_REQUESTED, function* (action) {
    try {
      const classifications = yield call(
        actions.searchClassifications,
        action.payload
      );
      yield put({
        type: actions.SEARCH_CLASSIFICATION_SUCCEEDED,
        classifications,
      });
    } catch (error) {
      yield put({
        type: actions.SEARCH_CLASSIFICATION_FAILED,
        error: error.message,
      });
    }
  });
}

export function* deleteClassification() {
  yield takeEvery(actions.DELETE_CLASSIFICATION_REQUESTED, function* (action) {
    try {
      const classification = yield call(
        actions.deleteClassification,
        action.payload
      );
      yield put({
        type: actions.DELETE_CLASSIFICATION_SUCCEEDED,
        classificationDeleted: classification,
      });
    } catch (error) {
      const errorMsg = getErrorMessage(error);
      message.error(errorMsg);
      yield put({
        type: actions.DELETE_CLASSIFICATION_FAILED,
        error: errorMsg,
      });
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(getClassifications),
    fork(searchClassifications),
    fork(getClassification),
    fork(deleteClassification),
  ]);
}
